export const paths = {
  /** A shared "Tipsa en kompis" link. */
  start: {
    getHref: (code: string) => `/start?code=${encodeURIComponent(code)}`,
  },

  auth: {
    register: {
      getHref: (redirect?: string | null | undefined) =>
        `/auth/register${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`,
    },
    login: {
      getHref: (redirect?: string | null | undefined) =>
        `/auth/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`,
    },
    bankid: {
      getHref: (redirect?: string | null | undefined) =>
        `/auth/bankid${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`,
    },
    context: {
      getHref: () => `/auth/context`,
    },
    verify: {
      getHref: (authenticationId: string, redirect?: string | null | undefined) =>
        `/auth/verify?authenticationId=${authenticationId}${
          redirect ? `&redirect=${encodeURIComponent(redirect)}` : ''
        }`,
    },
  },

  sales: {
    root: {
      getHref: () => `/sales`,
    },
    create: {
      getHref: () => `/sales/create`,
    },
  },

  sale: {
    overview: {
      getHref: (id: string) => `/sales/${id}/overview`,
    },
    participations: {
      getHref: (id: string) => `/sales/${id}/participations`,
    },
    orders: {
      getHref: (id: string) => `/sales/${id}/orders`,
    },
  },

  groups: {
    register: {
      getHref: () => `/groups/register`,
    },
  },

  group: {
    onboarding: {
      getHref: () => `/group/onboarding`,
    },
    memberships: {
      getHref: () => `/group/memberships`,
    },
    settings: {
      root: {
        getHref: () => `/group/settings`,
      },
      general: {
        getHref: () => `/group/settings/general`,
      },
      payout: {
        getHref: () => `/group/settings/payout`,
      },
    },
    registered: {
      getHref: (id: string) => `/groups/${id}/registered`,
    },
  },

  memberships: {
    register: {
      getHref: (code: string) => `/invite/${code}`,
    },
  },

  membership: {
    registered: {
      getHref: (id: string) => `/groups/${id}/memberships/registered`,
    },
  },

  user: {
    root: {
      getHref: () => `/user/general`,
    },
    general: {
      getHref: () => `/user/general`,
    },
    memberships: {
      getHref: () => `/user/memberships`,
    },
    security: {
      getHref: () => `/user/security`,
    },
  },
};
